import React, { Fragment, useEffect, useState } from "react";
import { CustomersFileType } from "../Common/Types/types";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import CustomerFilesTreeView from "./TreeView";

import { CustomersApi } from "./api";
interface CustomersWidgetProps {
  id: string;
  header: string;
  machine: string;
}

const CustomersFilesWidget = (props: CustomersWidgetProps) => {
  const [loading, updateLoading] = useState<boolean>(false);
  const [customerData, updateCustomerData] = useState<CustomersFileType[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>(null);

  useEffect(() => {
    fetchCustomersRootFolders();
  }, [props.machine]);
  const fetchCustomersFiles = (item: any): void => {
  //  console.log(item, customerData);
    updateLoading(true);
    updateCustomerData(null);

    let newParams: any = {};
    newParams.path = item.prefix != null ? item.prefix : item.path;

    newParams.container = item.container;

    CustomersApi.getAzureMachineFiles(newParams)
      .then((response: any) => {
        if (response != "canceled") {
          processFiles(response, item);
        }
      })
      .catch((error) => {
        if (error.message != "canceled") {
          updateLoading(false);
          setErrorMessage("Oops something went wrong, unable to get data.");
        }
        console.log(error);
      });
  };
  function processFiles(response: any, currentItem: any): void {
    const newData = mapCustomerFiles(response);
    const updatedCustomerData = updateCustomerDataItems(
      newData,
      currentItem,
      customerData
    );
   // console.log(updatedCustomerData);
    updateCustomerData(updatedCustomerData);
    updateLoading(false);
    setErrorMessage(null);
  }

  function mapCustomerFiles(files: any) {
    return files.map(({ isFolder, path, url, name, container, prefix }) => ({
      text: name,
      expanded: false,
      isFolder,
      path,
      url,
      name,
      container,
      prefix,
    }));
  }

  function updateCustomerDataItems(newItems: any, currentItem: any, cData) {
    return cData.map((dataItem) => {
      if (
        dataItem.text === currentItem.text &&
        dataItem.path === currentItem.path
      ) {
        // If the item matches the current item, update it with the new items
        return { ...dataItem, expanded: true, items: newItems };
      } else if (dataItem.items && dataItem.items.length > 0) {
        // If the item has children, recurse into them
        return {
          ...dataItem,
          items: updateCustomerDataItems(newItems, currentItem, dataItem.items),
        };
      }
      return dataItem;
    });
  }
  const fetchCustomersRootFolders = (): void => {
    updateLoading(true);
    updateCustomerData(null);
    let newParams: any = { machineSerial: props.machine };

    CustomersApi.getMachineRoot(newParams)
      .then((response: any) => {
        if (response != "canceled") {
          const mappedData = response.map((item) => {
            const { isFolder, path, url, name, container, prefix } = item;
            return {
              text: item.name,
              expanded: false,
              isFolder,
              path,
              url,
              name,
              container,
              prefix,
              items: [{}],
            };
          });
          updateCustomerData(mappedData);

          updateLoading(false);
          setErrorMessage(null);
        }
      })
      .catch((error) => {
        if (error.message != "canceled") {
          updateLoading(false);
          setErrorMessage("Oops something went wrong, unable to get data.");
        }
        console.log(error);
      });
  };

  if (loading) {
    return <Spinner text="data" />;
  } else if (customerData != null && customerData.length == 0) {
    return (
      <ErrorMessage
        text={"No data found for selected filters."}
        id={props.id}
        header={props.header}
      />
    );
  } else if (errorMessage) {
    return (
      <ErrorMessage text={errorMessage} id={props.id} header={props.header} />
    );
  } else if (customerData != null && customerData.length > 0) {
    return (
      <>
        <CustomerFilesTreeView
          data={customerData}
                itemClick={fetchCustomersFiles}
                source="azure"
        />
      </>
    );
  }
};
export default CustomersFilesWidget;
